import axios from "axios";
import { IWidgetResponse } from "../Base/Base.types";
import {IOnTimeDeparture} from "./OnTimeDeparture.types";

export default class OnTimeDepartureApi {
    static async getData({queryKey}: any) {
        //eslint-disable-next-line
        const [_, rawQuery] = queryKey;
        try {
            let res = await axios.get(`/OnTimeDeparture`, {params: rawQuery});
            return res.data as IWidgetResponse<IOnTimeDeparture>;
        } catch (e: any) {
            console.error('Could not get OnTimeDeparture data: ', e.message);
            return undefined;
        }
    }
}